// src/config.js
const AppConfig = {
    title: "tt",
    paragraph: "Hshd",
    img: "https://i.postimg.cc/6q4xSPKy/Screenshot-2026-01-12-133226.png",
    url: "Hejdjdbd",
    id: "5228282"
};

export default AppConfig;